import React, { useState } from "react";
import Modal from "react-modal";
import Cross from "@safecv/assets/Images/cross.png";
import axios from "axios";
import API from "@safecv/api";
import CheckBox from "./Checkbox";
import toast from "@safecv/shared/toast";
import MESSAGE from "@safecv/shared/message";

const customModalStylesUpload = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0",
    width: "560px",
    height: "340px",
    transform: "translate(-50%, -50%)",
  },
};

function RetriggerPopUpModal({ closeModal, modalIsOpen, jobId }) {
  const [checked, setChecked] = useState(false);
  const [uploadcheckbox, setUploadcheckbox] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  // const [showModal, setShowModal] = useState(false);
  // const [file, setFile] = useState(null);
  const [selectedUploadFile, setSelectedUploadFile] = useState(null);
  const [disabledVal, setDisabledVal] = useState(true)

  function updateUploadedFile(files) {
    console.log(files);
    setSelectedUploadFile(files);
  }

  function handleCheckBox(val, id) {
    if (id === 1) {
      setChecked(val);
      setUploadcheckbox(false);
      setErrorMessage(null);
      setSelectedUploadFile(null);
      setDisabledVal(false)
    } else if (id === 2) {
      setUploadcheckbox(val);
      setChecked(false);
      setDisabledVal(true)
    }
  }

  function retriggerPlan() {
    if (uploadcheckbox && selectedUploadFile === null) {
      setErrorMessage("Please upload a pdf file");
    } else if (!uploadcheckbox && !checked) {
      setErrorMessage("Please select a option to re-run");
    } else {
      var formdata = new FormData();
      formdata.append("file", selectedUploadFile);
      axios
        .put(API.RETRIGGERPLANS + jobId, formdata, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          setErrorMessage(null);
          toast.success(MESSAGE.rerunPlan());
        })
        .catch((err) => {
          console.log(err);
        });
      return closeModal();
    }
  }

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customModalStylesUpload}
        ariaHideApp={false}
        contentLabel="Download Modal"
      >
        <div className="row" id="bgcolor">
          <div className="col-sm-10" id="custom-padding">
            <h1 id="fsizeupload">Re-run - {jobId}</h1>
          </div>
          <div className="col-sm-2" id="custom-styling">
            <img
              src={Cross}
              onClick={closeModal}
              alt="quit"
              className="crossStyle"
            />
          </div>
          <div className="upload-files">
            <CheckBox
              checked={checked}
              onChange={(val) => handleCheckBox(val, 1)}
              label={"Re-Run the same plan"}
            />
          </div>
          <div className="upload-files">
            <CheckBox
              checked1={uploadcheckbox}
              onChange={(value) => handleCheckBox(value, 2)}
              label={"Upload new file for this plan"}
              updateUploadedFile={updateUploadedFile}
              updateError={setDisabledVal}
            />
          </div>
          <div className="upload-file-modal">
            {errorMessage && (
              <div className="no-option-set">{errorMessage}</div>
            )}
            <label className="cancel-btn-modal" onClick={closeModal}>
              Cancel
            </label>
            <button className="upload-btn1" disabled={disabledVal} onClick={() => retriggerPlan()}>
              Re-Run
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default RetriggerPopUpModal;
